module.exports = __webpack_public_path__ + "img/pdgt_ks.20c257ba.jpg";